export default "__VITE_ASSET__D63qAXGe__"